module.exports = __webpack_public_path__ + "img/giftbox.9c93039f.png";